<template>
  <div class="card">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col orange">
            <h3><i class="fas fa-box"></i>Set Bid Quantity</h3>
          </div>
          <div class="text-right">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> Set/Trader</a>
          </div>
      </div>
    </div>
    <div class="card-body">
      <div class="input-group mb-2">
          <label 
            for="inputEmail3" 
            class="col-form-label">
            Max. # Of Cusip <i class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="appMessages.maxOfCusipTooltipText"></i>
          </label>
          <input onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="number" class="form-control" placeholder="Max Qty" v-model="maxCusips">
          <div class="input-group-append">
            <button :disabled="maxCusips == 0" @click="setMaxCusip()" type="button">
              <i v-if="!maxQtyLoadingFlag" class="fas fa-check" v-bind:class="maxCusips == 0 ? 'fa-disabled' : ''"></i>
              <i v-if="maxQtyLoadingFlag" class="fa fa-spinner fa-spin"></i>
              </button>
          </div>
      </div>
      <div class="input-group mb-4">
          <label 
            for="inputEmail3" 
            class="col-form-label">
             Max. Par Value/Cusip <i class="fas fa-info-circle info" data-toggle="tooltip" v-bind:title="appMessages.maxParvalueTooltipText"></i>
          </label>
          <input onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="text" class="form-control" placeholder="Max  Par Value:  /Cusip" v-model="maxParValue">
          <div class="input-group-append">
            <button :disabled="maxParValue == 0" @click="setParValue()" type="button">
              <i v-if="!maxQtyPerCusipLoadingFlag" class="fas fa-check" v-bind:class="maxParValue == 0 ? 'fa-disabled' : ''"></i>
              <i v-if="maxQtyPerCusipLoadingFlag" class="fa fa-spinner fa-spin"></i>
              </button>
          </div>
      </div>
    </div>
</div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";
export default {
  name: "setbidquantity",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.maxCusips = this.bidSettings.maxCusips;
        this.maxParValue = this.bidSettings.maxParValue + "";
      },
      deep: true
    },
     maxParValue: function(newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => this.maxParValue = result);
    }
  },
  data() {
    return {
      accessToken:null,
      maxCusips : 0,
      maxParValue : 0,
      maxQtyLoadingFlag : false,
      maxQtyPerCusipLoadingFlag : false,
      testObj : {hideNegligibleDecimalDigits:false, hideCurrencySymbol:false, hideGroupingSymbol:false}
    };
  },
  methods: {
    getBidQuantity(){

      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/outstandingbid",
            auth
        )
        .then(result => {
          console.log(result);
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    setParValue(){
      this.maxQtyPerCusipLoadingFlag = true;
      if(parseFloat(this.maxParValue.replace(/,/g, '')) % 5){
        this.maxQtyPerCusipLoadingFlag = false;
        this.$alert(this.appMessages.parValueMultipleFiveError,"","warning");     
        return false
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/organization/bid-settings",
          {
            maxParValue: parseFloat(this.maxParValue.replace(/,/g, '')),
            orgType : "BID"
          },
          auth
        )
        .then(response => {
          console.log(response);
          this.$alert(this.appMessages.quantityUpdated);
          this.maxQtyPerCusipLoadingFlag = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    setMaxCusip(){
      this.maxQtyLoadingFlag = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/organization/bid-settings",
          { 
            maxCusips: this.maxCusips,
            maxParValue: parseFloat(this.maxParValue.replace(/,/g, '')),
            orgType : "BID"
          },
          auth
        )
        .then(response => {
          console.log(response);
          this.$alert(this.appMessages.quantityUpdated);
          this.maxQtyLoadingFlag = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    navigateListPage(){
      window.location.href = "/bidside/admin-setqtycapital";
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
       // this.getBidQuantity();
      }
    }); 
  }
};
</script>